import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import Swal from "sweetalert2";

export default function ManagePpdb() {
  const [list, setList] = useState([]);
  const ref = collection(db, "ppdb");

  /* ================= FETCH ================= */
  const fetchData = async () => {
    const snap = await getDocs(ref);
    setList(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= FORM ================= */
  const openForm = async (item = null) => {
    let jadwal = item?.jadwal || [
      { tahap: "Pendaftaran", mulai: "", selesai: "" }
    ];
    let persyaratan = item?.persyaratan || [""];
    let mekanisme = item?.mekanisme || [""];

    const renderForm = () => `
      <p class="text-start text-muted">
        <b>Catatan:</b> Tahap <b>Pendaftaran</b> wajib diisi
      </p>

      <input id="judul" class="swal2-input" placeholder="Judul PPDB"
        value="${item?.judul || ""}">

      <textarea id="deskripsi" class="swal2-textarea"
        placeholder="Deskripsi umum PPDB"
        style="height:90px">${item?.deskripsi || ""}</textarea>

      <hr/>
      <h6>📅 Jadwal PPDB</h6>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Tahap</th>
            <th>Mulai</th>
            <th>Selesai</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody id="jadwal-body">
          ${jadwal.map((j, i) => `
            <tr id="jadwal-row-${i}">
              <td><input class="form-control" id="tahap-${i}" value="${j.tahap}"></td>
              <td><input type="date" class="form-control" id="mulai-${i}" value="${j.mulai}"></td>
              <td><input type="date" class="form-control" id="selesai-${i}" value="${j.selesai}"></td>
              <td class="text-center">
                <button class="btn btn-danger btn-sm"
                  onclick="window.removeJadwalRow(${i})">❌ hapus </button>
              </td>
            </tr>
          `).join("")}
        </tbody>
      </table>
      <button class="btn btn-sm btn-outline-primary"
        onclick="window.addJadwalRow()">+ Tambah Tahap</button>

      <hr/>
      <h6>📋 Persyaratan</h6>
      <div id="syarat-body">
        ${persyaratan.map((p, i) => `
          <div id="syarat-row-${i}" class="d-flex gap-2 mb-2">
            <input class="swal2-input" id="syarat-${i}" value="${p}">
            <button class="btn btn-danger"
              onclick="window.removeSyaratRow(${i})">❌ Hapus </button>
          </div>
        `).join("")}
      </div>
      <button class="btn btn-sm btn-outline-primary"
        onclick="window.addSyaratRow()">+ Tambah Persyaratan</button>

      <hr/>
      <h6>🪜 Mekanisme Pendaftaran</h6>
      <div id="mekanisme-body">
        ${mekanisme.map((m, i) => `
          <div id="mekanisme-row-${i}" class="d-flex gap-2 mb-2">
            <input class="swal2-input" id="mekanisme-${i}" value="${m}">
            <button class="btn btn-danger"
              onclick="window.removeMekanismeRow(${i})">❌ Hapus </button>
          </div>
        `).join("")}
      </div>
      <button class="btn btn-sm btn-outline-primary"
        onclick="window.addMekanismeRow()">+ Tambah Langkah</button>

      <hr/>
      <h6>☎️ Kontak</h6>
      <input id="kontak" class="swal2-input"
        value="${item?.kontak || ""}">
    `;

    /* ================= ADD / REMOVE ================= */
    window.addJadwalRow = () => {
      const i = jadwal.length;
      jadwal.push({});
      document.getElementById("jadwal-body").insertAdjacentHTML("beforeend", `
        <tr id="jadwal-row-${i}">
          <td><input class="form-control" id="tahap-${i}"></td>
          <td><input type="date" class="form-control" id="mulai-${i}"></td>
          <td><input type="date" class="form-control" id="selesai-${i}"></td>
          <td class="text-center">
            <button class="btn btn-danger btn-sm"
              onclick="window.removeJadwalRow(${i})">❌ Hapus </button>
          </td>
        </tr>
      `);
    };

    window.removeJadwalRow = (i) => {
      document.getElementById(`jadwal-row-${i}`)?.remove();
    };

    window.addSyaratRow = () => {
      const i = persyaratan.length;
      persyaratan.push("");
      document.getElementById("syarat-body").insertAdjacentHTML("beforeend", `
        <div id="syarat-row-${i}" class="d-flex gap-2 mb-2">
          <input class="swal2-input" id="syarat-${i}">
          <button class="btn btn-danger"
            onclick="window.removeSyaratRow(${i})">❌ Hapus </button>
        </div>
      `);
    };

    window.removeSyaratRow = (i) => {
      document.getElementById(`syarat-row-${i}`)?.remove();
    };

    window.addMekanismeRow = () => {
      const i = mekanisme.length;
      mekanisme.push("");
      document.getElementById("mekanisme-body").insertAdjacentHTML("beforeend", `
        <div id="mekanisme-row-${i}" class="d-flex gap-2 mb-2">
          <input class="swal2-input" id="mekanisme-${i}">
          <button class="btn btn-danger"
            onclick="window.removeMekanismeRow(${i})">❌ Hapus </button>
        </div>
      `);
    };

    window.removeMekanismeRow = (i) => {
      document.getElementById(`mekanisme-row-${i}`)?.remove();
    };

    const { value: form } = await Swal.fire({
      title: item ? "Edit Informasi PPDB" : "Tambah Informasi PPDB",
      width: 900,
      html: renderForm(),
      showCancelButton: true,
      confirmButtonText: "Simpan",
      preConfirm: () => {
        const hasilJadwal = jadwal
          .map((_, i) => {
            const tahap = document.getElementById(`tahap-${i}`);
            if (!tahap) return null;
            return {
              tahap: tahap.value,
              mulai: document.getElementById(`mulai-${i}`).value,
              selesai: document.getElementById(`selesai-${i}`).value,
            };
          })
          .filter(Boolean);

        if (!hasilJadwal.some(j =>
          j.tahap.toLowerCase().includes("pendaftaran") &&
          j.mulai && j.selesai
        )) {
          Swal.showValidationMessage(
            "Tahap Pendaftaran wajib diisi"
          );
          return false;
        }

        return {
          judul: document.getElementById("judul").value,
          deskripsi: document.getElementById("deskripsi").value,
          jadwal: hasilJadwal,
          persyaratan: persyaratan
            .map((_, i) => document.getElementById(`syarat-${i}`))
            .filter(Boolean)
            .map(el => el.value),
          mekanisme: mekanisme
            .map((_, i) => document.getElementById(`mekanisme-${i}`))
            .filter(Boolean)
            .map(el => el.value),
          kontak: document.getElementById("kontak").value,
        };
      }
    });

    if (!form) return;

    item
      ? await updateDoc(doc(db, "ppdb", item.id), form)
      : await addDoc(ref, form);

    Swal.fire("Berhasil", "Informasi PPDB tersimpan", "success");
    fetchData();
  };

  /* ================= UI ================= */
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-3">
        <h3>Kelola PPDB</h3>
        <button className="btn btn-primary" onClick={() => openForm()}>
          + Tambah PPDB
        </button>
      </div>

      <div className="list-group">
        {list.map(item => (
          <div key={item.id}
            className="list-group-item d-flex justify-content-between">
            <div>
              <strong>{item.judul}</strong>
              <div className="small text-muted">
                {item.jadwal?.length} Tahap Jadwal
              </div>
            </div>
            <div>
              <button className="btn btn-warning btn-sm me-2"
                onClick={() => openForm(item)}>Edit</button>
              <button className="btn btn-danger btn-sm"
                onClick={() =>
                  deleteDoc(doc(db, "ppdb", item.id)).then(fetchData)
                }>Hapus</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
